// extracted by mini-css-extract-plugin
module.exports = {"QuestionRow":"RadioRow_QuestionRow__3AgTz","QuestionText":"RadioRow_QuestionText__1a44b","QuestionAnswers":"RadioRow_QuestionAnswers__3byPe"};